import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useAtom                } from "jotai";
import { Button                 } from "./Controls/Button";
import { ReserveInitResp        } from "./Data/ApiTypes";
import { showMoney              } from "./Data/Money";
import { showDuration           } from "./Data/Date";
import { maskAtom, PageMaskOpts, authAtom } from "./Data/Atoms";
import { Api } from "./Data/Api";
import { connectUrl } from "./Data/WebUrl";
import { createApiService } from './shared/apiConfig';
import { ParkingValidationRequestApi } from './shared/api/axios-client';
import { toast } from 'react-toastify';

export function StripeHourlyCheckoutForm( { reservationDetails, requestId }: { reservationDetails: ReserveInitResp, requestId?: string } ) {
    const stripe   = useStripe();
    const elements = useElements();
    const [ auth, setAuth ] = useAtom( authAtom );

    const maskOptions: PageMaskOpts = {
        showMask: true,
        header:  <div className="h2">Processing Payment</div>,
        subText: 'Do not close your browser',
    };
    const [, setShowMask] = useAtom( maskAtom );

    const handleSubmit = async ( event: any ) => {
        event.preventDefault();
        if( !stripe || !elements ) {
            return;
        }
        setShowMask( maskOptions );

        if (requestId)
        {
            const validationApi = createApiService(ParkingValidationRequestApi);
            const response = await validationApi.completeParkingValidationRequest({requestId});
            if (response.data.error)
            {
                toast.error("Validation Request not found");
                return;
            }
        }

        //not super essential, but marks it as submitted in our system
        const confirmRes = await Api.reservationConfirm( { orderId: reservationDetails.orderId } );
        const result = await stripe.confirmPayment( {
            elements,
            // assume if not logged in, they paid as a guest
            confirmParams: { return_url: connectUrl( "/paid?source=hourly" ) },
        } );

        if( result.error ) {
            // Show error to your customer (for example, payment details incomplete)
            console.log( result.error.message );
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }

        setShowMask(undefined);
    };

    return <form onSubmit={handleSubmit}>
            <PaymentElement />
            <div className="d-flex justify-content-end">
                <Button type="submit" disabled={!stripe} className="mt-3 px-3 btn-main">
                        Pay {showMoney( reservationDetails.price )} for {showDuration( reservationDetails.stayDuration )}
                </Button>
            </div>
        </form>
};

